import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { apiLight } from '../../common/lib/api'

const defaultOptions = {}

// use this hook if you don't need persistence in redux store
// for light api calls, that should be forgotten
export const useApiFetchLight = (url, options = defaultOptions) => {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const viewer = useSelector(state => state.app?.viewer)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const res = await apiLight({ viewer, url, ...options })
        setData(res?.data)
      } catch (e) {
        setError(e)
      } finally {
        setLoading(false)
      }
    }
    fetchData()
  }, [url, options, viewer?.tokens?.access])

  return { data, error, loading }
}
